import AuctionCause from '@c/auctions/AuctionCause';
import { AuctionStatus } from '@c/auctions/AuctionStatus';
import { BidHistoryTable } from '@c/auctions/BidHistoryTable';
import { ProductDocument } from 'models/product';
import { useAuth } from 'context/AuthContext';
import { PlaceABidButton } from 'features/auctions/components/PlaceABidButton';

const AuctionActions = ({ product }: { product: ProductDocument }) => {
  const { user } = useAuth();

  const auction_is_live =
    product.seller_id !== user?.uid &&
    product.end_time! > Date.now() &&
    product.start_time! < Date.now();

  return (
    <div className="flex flex-col gap-[1.6rem]">
      <AuctionStatus product={product} />
      {auction_is_live && <PlaceABidButton product={product} />}
      <BidHistoryTable product={product} />
      <AuctionCause product={product} />
    </div>
  );
};

export default AuctionActions;
